import { useMutation } from "@tanstack/react-query";
import { logCustomerQuery } from "../../service/query/auth";
import { toast } from "react-toastify";

export const useLogCustomerQuery = ({ onSuccess }) => {
  return useMutation({
    mutationFn: logCustomerQuery,
    onSuccess: (data) => {
      toast.success(data?.data?.message ?? "Query logged successfully");
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message ?? "An error occurred");
    },
  });
};